import { useEffect } from "react";
import type { CheckTaskDTO } from "@shared/types";
import { useTaskDraft } from "@/stores/taskDraft";
import { useConnection } from "@/stores/connection";
import { api } from "./api";
import { endpoints } from "./endpoints";
import { queryClient } from "./queryClient";
import { queryKeys } from "./queryKeys";
import { useMyChecks, useScope } from "./queries";

/**
 * Put today's checks for the signed-in person on this phone as the app
 * starts, so they can walk into a room with no signal and still run them.
 */
export function usePrefetchMyChecks() {
  const { primary } = useScope();
  const online = useConnection((s) => s.online);
  const mine = useMyChecks(online ? primary?.id : undefined, { poll: false }).data?.mine;
  const remember = useTaskDraft((s) => s.remember);
  useEffect(() => {
    if (!mine || !online) return;
    const have = useTaskDraft.getState().drafts;
    for (const t of mine) {
      if (have[t.id]?.task) continue;
      void queryClient
        .fetchQuery({ queryKey: queryKeys.upkeep.task(t.id), queryFn: () => api<CheckTaskDTO>(endpoints.upkeep.task(t.id)) })
        .then(remember)
        .catch(() => undefined);
    }
  }, [mine, online, remember]);
}
